<template>
  <div class="brillouin-viz">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex>$<strong>公式：</strong>Δf = ±2n·v/λ · sin(θ/2)$</div>
    </div>

    <div class="main-layout vertical">
      <div class="canvas-box simulation">
        <svg width="100%" height="240" viewBox="0 0 400 240">
          <!-- The Medium -->
          <rect x="50" y="40" width="300" height="160" fill="rgba(255,255,255,0.02)" stroke="#444" />
          
          <!-- Acoustic Waves (Phonons) - Moving density tiers -->
          <g v-for="i in 10" :key="i">
             <line :x1="50 + i*30 + offset" y1="40" :x2="50 + i*30 + offset" y2="200" stroke="rgba(0, 210, 255, 0.2)" stroke-width="2" />
          </g>

          <!-- Incident Photon -->
          <path d="M 20,40 L 200,120" stroke="#fff" stroke-width="2" stroke-dasharray="4,2">
             <animate attributeName="stroke-dashoffset" from="100" to="0" dur="1s" repeatCount="indefinite" />
          </path>
          <text x="20" y="30" fill="#fff" font-size="8">入射光子 (ω)</text>

          <!-- Scattered Photon (Stokes/Anti-Stokes) -->
          <path d="M 200,120 L 380,40" stroke="#ff4757" stroke-width="2" />
          <text x="320" y="30" fill="#ff4757" font-size="8">散射光子 (ω ± Ω)</text>

          <circle cx="200" cy="120" r="5" fill="#ffd700" />
          <text x="210" y="135" fill="#ffd700" font-size="8">光子-声子 相互作用</text>
        </svg>

        <div class="hud-top">
           <div class="stat">
              <label>频移 Δf: 对应声速信息</label>
           </div>
        </div>
      </div>

      <div class="bottom-controls">
        <div class="discovery-note" v-latex>
           <p><strong>物理详解：</strong>布里渊散射是指光与介质中自发的声学振动（**声子**）发生相互作用的现象。入射光子被周期性的声压波反射，由于多普勒效应，散射光的频率会发生微小偏移。与拉曼散射相比，布里渊散射涉及的频移更小，主要反映了介质的**弹性常数、声速和阻尼**特性。它在光纤传感和凝聚态物理研究中具有重要应用。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BrillouinScatteringViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      offset: 0
    }
  },
  methods: {
    update() {
       this.offset = (this.offset + 1) % 30;
       requestAnimationFrame(this.update);
    }
  },
  mounted() { this.update(); },
  beforeDestroy() {
    if (this.animFrame) cancelAnimationFrame(this.animFrame);
    if (this.timer) clearInterval(this.timer);
  },
}
</script>

<style scoped lang="scss">
.brillouin-viz { flex: 1; display: flex; flex-direction: column; gap: 12px; height: 100%; overflow: hidden; }
.canvas-box { background: #020205; border-radius: 12px; position: relative; border: 1px solid rgba(255,255,255,0.05); }
.bottom-controls { flex: 0.6; display: flex; flex-direction: column; gap: 10px; }
.discovery-note { background: rgba(0, 210, 255, 0.05); padding: 12px 18px; border-radius: 12px; p { margin: 0; font-size: 0.75rem; color: #aaa; line-height: 1.5; strong { color: #fff; } } }
</style>
